<template>
    <div class="periodos">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="create_periodos" title="Agregar plataformas de transmicion">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <div>
                    <label for="">Fecha inicial del periodo</label>
                    <input type="date" name="" id="" v-model="fechaInicial">
                </div>
                <div>
                    <label for="">Fecha final del periodo</label>
                    <input type="date" name="" id="" v-model="fechaFinal">
                </div>
                <button @click="addNewPeriodo">Crear</button>
            </div>
        </b-modal>
        <div class="periodo-list">
            <div v-for="(item, index) in periods" :key="index" class="item" :class="{'create': item.status === 'create','process': item.status === 'process','completed': item.status === 'completed' }">
                <div class="close" @click="removePeriod(item.id)">X</div>
                <div class="item-periodo" @click="$router.push({path: 'habitaciones/' + item.id + '/info'})">
                    <h4 for="">{{ item.start_date.split($store.state.constants.SEPARETOR)[0] + ' - ' + item.finish_date.split($store.state.constants.SEPARETOR)[0]}}</h4>
                    <h5>{{ item.status }}</h5>
                </div>
            </div>
            <div class="item">
                <div class="item-periodo" @click="$refs.create_periodos.show()">
                    <h2 for="">Agregar nuevo periodo</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
export default {
    name: 'periodos',
    data() {
        return {
            periods: [],
            fechaInicial: null,
            fechaFinal: null
        }
    },
    methods: {
        getPeriods() {
            API.getPeriods()
                .then((res) => {
                    console.log(res)
                    this.periods = res
                })
        },
        addNewPeriodo() {
            if (this.fechaFinal === null && this.fechaInicial === null) {
                return
            }
            API.addNewPeriod(this.fechaInicial, this.fechaFinal)
                .then((res) => {
                    this.$refs.create_periodos.hide()
                    this.getPeriods()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        removePeriod(id) {
            API.removePeriod(id)
                .then((res) => {
                    this.getPeriods()
                })
        }
    },
    mounted() {
        this.getPeriods()
    }
}
</script>

<style scoped>
    .periodos {
        background-color: #e0b059;
        height: 90vh;
    }
    .periodos > .periodo-list {
        padding: 50px;
        overflow-y: auto;
        display: inline;
    }
    .periodos > .periodo-list > .item{
        width: 300px;
        height: 200px;
        float: left;
        background-color: antiquewhite;
        margin: 10px;
        position: relative;
    }
    .periodos > .periodo-list > .item.create{
        width: 300px;
        height: 200px;
        background-color:darkgray;
        float: left;
        margin: 10px;
    }
    .periodos > .periodo-list > .item.process{
        width: 300px;
        height: 200px;
        background-color: chartreuse;
        float: left;
        margin: 10px;
    }
    .periodos > .periodo-list > .item.completed{
        width: 300px;
        height: 200px;
        background-color:darkred;
        float: left;
        margin: 10px;
    }
    .periodos > .periodo-list > .item > .item-periodo {
        padding: 20px;
        position: relative;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
    .periodos > .periodo-list > .item > .item-periodo > .close{
        color: black;
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
    }
    .periodos > .periodo-list > .item > .item-periodo > .close:hover{
        color: red;
    }
    .periodos > .periodo-list > .item > .item-periodo > h4 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .periodos > .periodo-list > .item > .item-periodo > h2 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }
    .periodos > .periodo-list > .item > .item-periodo > h5 {
        position: absolute;
        left: 50%;
        top: 80%;
        transform: translate(-50%, -50%);
        text-align: center;
    }
    .info-wrapper > button {
        margin: auto;
        margin-top: 35px;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Habitaciones/Periodos.vue